import { render, staticRenderFns } from "./create-referral.vue?vue&type=template&id=abfc3954&"
import script from "./create-referral.vue?vue&type=script&lang=js&"
export * from "./create-referral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports